export default __webpack_public_path__ + "static/media/home_divier.bb845d00.svg";